import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import ExpertDataService from "../../services/Expert";
import { generateEventsForCurrentWeek } from "../../Config/Expert";

export const ClearEventModal = ({
  isOpen,
  onClose,
  timing,
  id,
  func,
  targetDay,
}: any) => {
  const [day, setDay] = useState<any>("");
  const [selectedDay, setSelectedDay] = useState<string>("");
  const [time, setTime] = useState<any>([]);
  const [newTiming, setNewTiming] = useState(timing);
  const handleDays = (dayName: string) => {
    setDay(dayName);
    setTime(timing[dayName]);
  };
  const handleRemove = (el: any) => {
    const filteredArray = time.filter((data: any) => data !== el);
    setTime(filteredArray);
    setNewTiming({ ...newTiming, [day]: filteredArray });
  };
  const dayExist = (dayname: string) => {
    if (day === dayname) {
      return true;
    } else {
      return false;
    }
  };
  const handleSubmit = () => {
    const events = generateEventsForCurrentWeek(newTiming);
    setDay("");
    ExpertDataService.postCalenderInfo(id, newTiming)
      .then((res: any) => {
        func(newTiming);
      })
      .catch((error: any) => {
        console.log(error);
      });
    onClose();
  };
  useEffect(() => {
    if (targetDay && targetDay !== selectedDay) {
      setSelectedDay(targetDay);
      handleDays(targetDay);
    }
  }, [targetDay, selectedDay]);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Clear Event</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <FormControl>
            <h5>Week Days</h5>
            <Flex>
              <span
                title="Monday"
                className={
                  dayExist("mon") ? "week_days clicked_week_days" : "week_days"
                }
                onClick={() => handleDays("mon")}
              >
                M
              </span>
              <span
                title="Tuesday"
                className={
                  dayExist("tue") ? "week_days clicked_week_days" : "week_days"
                }
                onClick={() => handleDays("tue")}
              >
                T
              </span>
              <span
                title="Wednesday"
                className={
                  dayExist("wed") ? "week_days clicked_week_days" : "week_days"
                }
                onClick={() => handleDays("wed")}
              >
                W
              </span>
              <span
                title="Thursday"
                className={
                  dayExist("thu") ? "week_days clicked_week_days" : "week_days"
                }
                onClick={() => handleDays("thu")}
              >
                T
              </span>
              <span
                title="Friday"
                className={
                  dayExist("fri") ? "week_days clicked_week_days" : "week_days"
                }
                onClick={() => handleDays("fri")}
              >
                F
              </span>
              <span
                title="Saturday"
                className={
                  dayExist("sat") ? "week_days clicked_week_days" : "week_days"
                }
                onClick={() => handleDays("sat")}
              >
                S
              </span>
              <span
                title="Sunday"
                className={
                  dayExist("sun") ? "week_days clicked_week_days" : "week_days"
                }
                onClick={() => handleDays("sun")}
              >
                S
              </span>
            </Flex>
          </FormControl>
          <h5 className="pt-3">Time Slots</h5>
          {time.length > 0
            ? time.map((el: any, index: number) => {
                return (
                  <div key={index}>
                    <Flex
                      className="expert_time"
                      justifyContent={"space-evenly"}
                    >
                      <div>Start : {el.start}</div>
                      <div>End : {el.end}</div>
                      <div className="pointer" onClick={() => handleRemove(el)}>
                        Remove
                      </div>
                    </Flex>
                  </div>
                );
              })
            : null}
        </ModalBody>

        <ModalFooter>
          <Button className="act-btn" mr={3} onClick={handleSubmit}>
            Save
          </Button>
          <Button onClick={onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
